import { Card, CardHeader, CardTitle, CardContent } from "@/shadcn_components/ui/card";
import { Input } from "@/shadcn_components/ui/input";
import { Label } from "@/shadcn_components/ui/label";
import TextareaInput from '@/components/refinedev/TextareaInput';

const JobForm = () => {
return (
<div className="max-w-lg mx-auto p-6">
    <Card>
    <CardHeader>
        <CardTitle>Công việc</CardTitle>
        <p className="text-sm text-gray-500">Nhập thông tin công việc</p>
    </CardHeader>
    <CardContent>
        <div className="space-y-4">
            <Label htmlFor="title" className="text-lg">Tên công việc</Label>
            <Input id="title" placeholder="Nhập tên công việc" className="mt-1" />
            <TextareaInput source="description" placeholder="Nhập mô tả công việc" label="Mô tả công việc" />
        </div>
    </CardContent>
    </Card>
</div>
);
};

export const transformBeforeSave = (data) => {
return data;
};

JobForm.transformBeforeSave = transformBeforeSave;

export default JobForm;
